import React, { FC, useState, useEffect, useContext } from 'react'
import { usePromiseTracker, trackPromise } from 'react-promise-tracker'
import { isTablet, isMobile } from 'react-device-detect'
import history from '../../../history'
import { Collapse } from 'react-collapse';
import { Modal } from 'react-responsive-modal'
import AppContext from '../../../context/appContext'

import InfoModal from '../components/InfoModal'


import {
  getFolders,
  getUserData,
  getMainpageAds,
  getMissingSteps,
  getPromoInfo,
} from '../../../Api/backendApi'
import { getAllUserWatchedVideos } from '../../../Api/challengesApi'

import { albumType } from '../../../utils/albumCategories'
import { getChallengeCategories } from '../../../Api/challengesApi'

import GenericBackgroundLayer from '../../../GenericComponents/GenericBackgroundLayer'
import Navigation from '../components/Navigation/Navigation'
import MainpageCarousel from '../../MainScreen/views/MainpageCarousel'
import { MainScreenBanner, BannerShopButton, BannerDietButton } from '../../MainScreen/styles/MainScreenStyles'
import GenericIcon from '../../../GenericComponents/GenericIcon'
import DietAdBanner from "../../../assets/REDESIGN_Assets/MainScreen/diet-ad-banner.jpg"
import GenericRow from '../../../GenericComponents/GenericRow'
import GenericTextSpan from '../../../GenericComponents/GenericTextSpan'
import { NavContainer, SwitchContainer } from "../style"
import "../style/style.css"
import GenericColumn from '../../../GenericComponents/GenericColumn'

// @ts-ignore: not important error
import { IoIosArrowDropup, IoIosArrowDropdown } from "react-icons/io";
import { AiOutlineInfoCircle } from "react-icons/ai";



export const modalStyles = {
  closeButton: {
    display: 'none',
  },
  modal: {
    maxWidth: isMobile ? '90vw' : '55vw',
    width: isMobile ? '95vw' : '55vw',
    overflow: 'unset',
    left: isMobile ? '-4.5%' : '0',
    boxsizing: 'border-box',
    margin: isMobile ? 'auto' : 'unset',
    borderRadius: '30px',
  },
}

interface ChallengesMainScreenInterface { }

const ChallengesMainScreen: FC<ChallengesMainScreenInterface> = ({ }) => {
  const appContext = useContext(AppContext)

  const [userHasDietModule, setUserHasDietModule] = useState(false)
  const [isDemoUserRedirectToSubModalOpen, setDemoUserRedirectToSubModalOpen] =
    useState(false)
  const [folders, setFolders] = useState()
  const [normalFolders, setNormalFolders] = useState()
  const [adds, setAddsData] = useState(Object)
  const [user, setUser] = useState(Object)
  const [challengeCategories, setChallengeCategories] = useState<any>()
  const [isCollapsedHeader, setCollapsedHeader] = useState(false)
  const [isInfoModalOpen, setInfoModalOpen] = useState(false)


  useEffect(() => {
    obtainUser()
    obtainFolders()
    obtainAdds()
    obtainChallengesAlbums()
    getChallengeCategorie()
  }, [])

  const obtainChallengesAlbums = async () => {

    const challengeAlbums: any = await getAllUserWatchedVideos()
    setFolders(challengeAlbums)

  }


  const getChallengeCategorie = async () => {
    let challenges: any = await getChallengeCategories()

    if (challenges && challenges.length) {
      setChallengeCategories(challenges)
    }


  }


  const obtainUser = async () => {
    // if (appContext.appState.user) {
    //   setUser(appContext.appState.user)
    // }

    const user = await trackPromise(getUserData())
    setUser(user)
    // appContext.updateAppState('user', user)
  }


  const obtainFolders = async () => {
    // if (appContext.appState.albums) {
    //   setFolders(appContext.appState.albums)
    // }

    let folders: any = await trackPromise(getFolders())

    // const newFolders = folders.map((folder: any, map: number) => {
    //   return {
    //     currentVideo: folder.currentVideo,
    //     albums: folder.albums[0]
    //   }
    // })
    const newFolders: any = { currentVideo: folders.currentVideo, albums: [folders.albums[0]] }


    setNormalFolders(newFolders)
    // appContext.updateAppState('albums', folders)
  }

  const obtainAdds = async () => {
    // if (appContext.appState.adds) {
    //   setAddsData(appContext.appState.adds)
    // }

    let addsData: any = await trackPromise(getMainpageAds())

    setAddsData(addsData)

    // appContext.updateAppState('adds', addsData)
  }



  return (
    <GenericBackgroundLayer
      fDir={'column'}
      justify={'flex-start'}
      align={'center'}
      className={`${appContext.appState.theme == 'light' ? 'light' : 'standard'
        } challenge-main-screen`}

    >
      <Navigation userHasDietModule={userHasDietModule} />
      <MainScreenBanner>
        <GenericIcon
          src={adds && adds.img_url}
          // src={"https://fmw-bucket.s3.eu-central-1.amazonaws.com/diet-thumbnails/FMW-baner2.png"}
          className={'mainpage-diet-banner__first'}
          // src={MainScreenAdPlaceholder}
          height={
            window.innerWidth > 360 && !isTablet
              ? '13vh'
              : isTablet
                ? '9vh'
                : '17vh'
          }
          width={isMobile || isTablet ? '100%' : '50%'}
          backgroundSize={isMobile || isTablet ? '100% 100%' : '100% 100%'}
          backgroundPosition={'top'}
          onClick={() => (window.location.href = adds && adds.promo_url)}
        >
          <BannerShopButton className="first-banner">
            Odwiedź sklep
          </BannerShopButton>
        </GenericIcon>
        <GenericIcon
          onClick={userHasDietModule ? () => history.push('/dieta') : null}
          src={DietAdBanner}
          height={
            window.innerWidth > 360 && !isTablet
              ? '13vh'
              : isTablet
                ? '9vh'
                : '17vh'
          }
          backgroundPosition={'top'}
          width={isMobile || isTablet ? '100%' : '50%'}
          backgroundSize={isMobile || isTablet ? '100% 100%' : 'cover'}
          className={'mainpage-diet-banner mainpage-diet-banner__second'}
        // borderRadius={isMobile ? '30px' : 'unset'}
        >
          <BannerDietButton>Wybierz swoją dietę </BannerDietButton>
        </GenericIcon>
      </MainScreenBanner>


      <GenericRow margin="20px 0 0 0" wrap="wrap" className="responsive-width" justify="flex-start">
        <GenericColumn width={isMobile ? "100%" : "40%"} align="flex-start">
          <GenericRow>
            <GenericColumn justify="flex-start">
              <GenericTextSpan className={`${appContext.appState.theme == 'light' ? 'light' : ''
                }`} fSize="2.5rem" fWeight="bold" tAlign="left" width="100%">
                Cześć {user && user.name}
              </GenericTextSpan>
              <GenericTextSpan className={`${appContext.appState.theme == 'light' ? 'light' : ''
                }`} width="100%" tAlign="left" fWeight="300" color={"rgba(255,255,255,0.7)"} fSize="1.2rem">
                Super, że jesteś!
              </GenericTextSpan>
            </GenericColumn>
          </GenericRow>


          <GenericRow
            // className="mainpage-header-row"
            padding={'unset'}
            wrap={isMobile ? 'wrap' : 'unset'}
            margin={'1% auto'}
            width="100%"
          >
            <GenericRow width="100%" margin={isMobile && !isTablet ? "7% 0" : "5% 0"} justify="flex-start">
              <SwitchContainer>
                <GenericTextSpan className={`${appContext.appState.theme == 'light' ? 'light' : ''
                  }`} margin="0 5px 0 0">Pełna wersja MIAZGI</GenericTextSpan>
                <label className="switch">
                  <input type="checkbox" onChange={() => history.push({ pathname: "/redirect", state: { selectedMiazga: true } })} />
                  <span className="slider round"></span>
                </label>
                <GenericTextSpan className={`${appContext.appState.theme == 'light' ? 'light' : ''
                  }`} margin="0 0 0 5px">Wyzwania</GenericTextSpan>
              </SwitchContainer>
            </GenericRow>
          </GenericRow>

        </GenericColumn>

        <GenericColumn width={isMobile ? "100%" : "55%"} margin={isMobile ? "5% 0 5% 0" : "3% 0 0 0"} >
          <GenericTextSpan className={`${appContext.appState.theme == 'light' ? 'light' : ''
            }`} fWeight="bold" fSize="1.6rem" tAlign="left" width="100%" margin="0 0 2% 0">
            Cześć!
          </GenericTextSpan>
          <GenericTextSpan className={`${appContext.appState.theme == 'light' ? 'light' : ''
            }`} fSize="1rem" tAlign="left" width="100%" margin="0 0 2% 0" lineHeight="1.15rem">
            Witam Cię w panelu <b>„Wyzwania”</b>.
          </GenericTextSpan>
          <GenericTextSpan className={`${appContext.appState.theme == 'light' ? 'light' : ''
            }`} fSize="1rem" tAlign="left" width="100%" margin="0 0 2% 0" lineHeight="1.15rem">
            Wiem, jak lubisz treningi celowane w konkretne partie ciała, więc przygotowałam opcję, która Cię zachwyci. Poniżej masz do wyboru dwa Wyzwania, ale z czasem dojdą kolejne.
          </GenericTextSpan>
          <GenericRow className="pointer" justify="left" onClick={() => setInfoModalOpen(true)}>
            <AiOutlineInfoCircle className="icon-green" />
            <GenericTextSpan margin="0 0 0 5px" color={"#a1ff68"} fSize="1.2rem" tAlign="left" >
              Czytaj więcej...
            </GenericTextSpan>
          </GenericRow>
        </GenericColumn>
      </GenericRow>


      <MainpageCarousel
        conferencesTrainings={false}
        fullWidth={false}
        isConferences={false}
        onClick={undefined}
        isDemoMode={false}
        folders={normalFolders}
        albumType={albumType.pozaMiazgaChallenge.name}
        albumName={albumType.pozaMiazgaChallenge.label}
        categoryTag={albumType.pozaMiazgaChallenge.tag}
        setDemoUserRedirectToSubModalOpen={setDemoUserRedirectToSubModalOpen}
        challengeMode={true}
        miazgaPrepare={true}

      />

      {challengeCategories && challengeCategories.length &&

        challengeCategories.map((category: any) =>
          <>

            <MainpageCarousel
              conferencesTrainings={false}
              fullWidth={false}
              isConferences={false}
              onClick={undefined}
              isDemoMode={false}
              folders={folders}
              albumType={category.name}
              albumName={category.name}
              categoryTag={category.name}
              setDemoUserRedirectToSubModalOpen={setDemoUserRedirectToSubModalOpen}
              challengeMode={true}
              miazgaPrepare={true}
            />
          </>
        )
      }
      <Modal
        open={isInfoModalOpen}
        animationDuration={700}
        onClose={
          () => setInfoModalOpen(false)
        }
        center
        styles={modalStyles}
      >
        <InfoModal closeButtonAction={() => setInfoModalOpen(false)} />
      </Modal>
    </GenericBackgroundLayer >

  )
}

export default ChallengesMainScreen
